import { PERSISTENCE_KEY } from '@/store/config'
import { onLogout } from '@/apollo'

export default {
  methods: {
    logOut (redirectToAfterLogout = null) {
      document.querySelectorAll('body').forEach((elm) => {
        elm.classList.add('logging-out')
      })
      document.querySelectorAll('.disableOnLogout').forEach((elm) => {
        elm.setAttribute('disabled', 'disabled')
      })
      document.querySelectorAll('.hideOnLogout').forEach((elm) => {
        elm.style.display = 'none'
      })
      const component = this
      this.$store.dispatch('logout').then(function () {
        sessionStorage.removeItem(PERSISTENCE_KEY)
        onLogout(component.$apolloProvider.defaultClient)

        const portalLoginForm = document.querySelector('form.mod_login')
        if (portalLoginForm) {
          if (typeof redirectToAfterLogout === 'undefined' || redirectToAfterLogout === null) {
            redirectToAfterLogout = '/'
          }
          if (window.jQuery) {
            const targetPathInput = window.jQuery(portalLoginForm).find('input[name=_target_path]').get(0)
            window.jQuery(targetPathInput).val(redirectToAfterLogout)

            const alwaysTargetPath = window.jQuery(portalLoginForm).find('input[name=_always_use_target_path]').get(0)
            window.jQuery(alwaysTargetPath).val('0')
          }
          portalLoginForm.submit()
        } else if (component.extraData?.logoutUrl) {
          window.location = component.extraData.logoutUrl
        }
      })
    }
  }
}
